import React, { type FunctionComponent, useState } from 'react'
import { type RadiumStyles, SVGIcon } from 'ic-snacks'
import { Button } from '@retailer-platform/shared-components'
import { useEditProducts } from 'domains/products/components/search/utils/useEditProducts.hooks'
import { useSelectionManager } from 'utils/selection-manager/SelectionManager'
import { EditProductsModal } from 'domains/products/components/edit-products-modal/EditProductsModal'
import { useRetailerId, usePartnerId } from 'utils/routing/params.hooks'
import { type ProductSearchParams } from 'domains/products/components/search/utils/types'

const editProductsButtonCss: RadiumStyles = {
  display: 'flex',
  flexWrap: 'nowrap',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto',
  height: 40,
}

const editProductsSvgCss: RadiumStyles = {
  display: 'block',
  margin: 'auto',
  paddingTop: 1,
  height: 15,
}

interface ProductsSearchBulkEditButtonProps {
  searchParams: ProductSearchParams
}

export const ProductsSearchBulkEditButton: FunctionComponent<ProductsSearchBulkEditButtonProps> = ({
  searchParams,
}) => {
  const warehouseId = useRetailerId()
  const partnerId = usePartnerId()
  const [showModal, setShowModal] = useState(false)
  const { selectedCount, isGlobalSelection, selectedKeys } = useSelectionManager()

  const onSaveDepartmentAndAisle = useEditProducts({
    partnerId,
    warehouseId,
    setShowModal,
    searchTerm: searchParams.searchTerm,
    searchType: searchParams.searchType,
    localeCode: searchParams.locale,
    selectedCount,
    isGlobalSelection,
    selectedKeys,
  })

  return (
    <React.Fragment>
      <Button
        style={editProductsButtonCss}
        variant={'secondary'}
        onClick={() => setShowModal(true)}
      >
        {selectedCount}
        <SVGIcon style={editProductsSvgCss} name="pencilFilled" />
      </Button>

      {showModal && (
        <EditProductsModal
          retailerId={warehouseId}
          productCount={selectedCount}
          onClose={() => setShowModal(false)}
          onSave={onSaveDepartmentAndAisle}
        />
      )}
    </React.Fragment>
  )
}
